// extracted by mini-css-extract-plugin
export default {"inlineSpinner":"InlineSpinner_inlineSpinner__wXm-j","spin":"InlineSpinner_spin__GipIl"};